import { Risk } from '../types';

export const risks: Risk[] = [
  'at-risk',
  'below-normal',
  'normal-range',
  'top-performers',
];

export enum VehiclePart {
  Front = 'front',
  Rear = 'rear',
}

export enum VehicleSide {
  Left = 'left',
  Right = 'right',
}

export enum CarItem {
  LeftFrontFender = 'left-front-fender',
  RightFrontFender = 'right-front-fender',
  LeftFrontDoor = 'left-front-door',
  RightFrontDoor = 'right-front-door',
  LeftRearDoor = 'left-rear-door',
  RightRearDoor = 'right-rear-door',
  LeftQuarterPanel = 'left-quarter-panel',
  RightQuarterPanel = 'right-quarter-panel',
  LeftFrontWheel = 'left-front-wheel',
  RightFrontWheel = 'right-front-wheel',
  LeftRearWheel = 'left-rear-wheel',
  RightRearWheel = 'right-rear-wheel',
  FrontBumper = 'front-bumper',
  RearBumper = 'rear-bumper',
  FrontHood = 'front-hood',
  RearHood = 'rear-hood',
  FrontWindow = 'front-window',
  RearWindow = 'rear-window',
  Roof = 'roof',
}

export enum CargoItem {
  LeftDoor = 'left-door',
  RightDoor = 'right-door',
  LeftFrontWheel = 'left-front-wheel',
  RightFrontWheel = 'right-front-wheel',
  LeftRearWheel = 'left-rear-wheel',
  RightRearWheel = 'right-rear-wheel',
  FrontBumper = 'front-bumper',
  RearBumper = 'rear-bumper',
  FrontHood = 'front-hood',
  RearHood = 'rear-hood',
  Window = 'window',
  Сabin = 'cabin',
  Roof = 'roof',
}
